import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import ContentAllExceptIndex from '../components/content-all-except-index';
import ContentSnd from '../components/content-snd';
import Footer from '../components/footer';
import Segment from '../images/cortex-global-segment.svg';
import Link from 'gatsby-link';

const TermsAndCondition = () => {
	const fontSize = { fontSize: 30 };
	return (
		<Layout>
			<SEO title='Cortex - Terms and Conditions' />
			<ContentAllExceptIndex title='privacy'>
				<div className='cortex-home-content-nd'>Terms and Conditions</div>
			</ContentAllExceptIndex>
			<ContentSnd>
				<div className='cortex-privacy-content'>
					<div className='cortex-privacy-content-container'>
						<img src={Segment} alt='ctcSegment' />
						<div className='cortex-privacy-content-title'>TERMS OF USE</div>
						<p className='cortex-privacy-content-p'>Last revised: Sept 26 2017</p>
						<p className='cortex-privacy-content-p'>
							USE OF THIS MOBILE APPLICATION (THE “APPLICATION”) CONSTITUTES ACCEPTANCE OF THESE TERMS OF
							USE (“TERMS”), AS SUCH MAY BE REVISED BY CORTEX FROM TIME TO TIME, WHICH CONSTITUTE A
							BINDING AGREEMENT BETWEEN THE USER (“USER”) AND CORTEX TECHNOLOGIES CORPORATION ("CORTEX")
							GOVERNING THE USE OF THE APPLICATION. BY DOWNLOADING OR INSTALLING THIS APPLICATION USER
							ACKNOWLEDGES AND AGREES TO BE BOUND BY THESE TERMS. IF USER DOES NOT AGREE TO THESE TERMS
							USER SHOULD UNINSTALL THIS APPLICATION IMMEDIATELY.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Eligibility
						</div>
						<p className='cortex-privacy-content-p'>
							The Application may only be used by individuals aged eighteen (18) years or older. If the
							User is thirteen (13) years or older but under the age of eighteen (18) years, User should
							review these Terms with User’s parent or guardian to make sure the User and User’s parent or
							guardian understand them.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Apple Terms and Conditions; Cortex Policies
						</div>
						<p className='cortex-privacy-content-p'>
							These Terms supplement and incorporate (a) the Apple, Inc. (“Apple”) Terms and Conditions
							located at&nbsp;<a
								href='https://www.apple.com/legal/itunes/us/terms.html#service'
								target='_blank'
								rel='noopener noreferrer'
							>
								<span>www.apple.com/legal/tunes /us /terms.html#service</span>
							</a>&nbsp; including, without limitation, the Licensed Application End User License
							Agreement provided therein (“Apple Terms”); and other Cortex Technologies Corporation
							policies (“Cortex Policies”). If any of the provisions of the Apple Terms and Conditions or
							the any applicable Cortex Policies conflict with these Terms, these Terms will control,
							solely to the extent such terms apply to the Application.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							User License
						</div>
						<p className='cortex-privacy-content-p'>
							Subject to these Terms, Cortex grants the User a personal, non-exclusive, non-transferable,
							limited and revocable license to use the Application for personal and/or non-commercial use
							only on an Apple iPhone, iPad or iPod Touch (each a “Device”) owned or controlled by User as
							permitted by the Usage Rules contained in the Apple Terms and in accordance with these Terms
							(“User License”). Any use of the Application in any other manner, including, without
							limitation, resale, transfer, modification or distribution of the Application or text,
							pictures, music, barcodes, video, data, hyperlinks, displays and other content associated
							with the Application (“Content”) is prohibited. This Agreement and User License also governs
							any updates to, or supplements or replacements for, this Application unless separate terms
							accompany such updates, supplements or replacements, in which case the separate terms will
							apply.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Online Payment
						</div>
						<p className='cortex-privacy-content-p'>
							Users who download the Application to a Device may also elect to participate in certain
							functionality of the Application which will allow the User to access features not available
							without availing of an upgrade. Cortex reserves the right at any time to discontinue any or
							all of the functions of Online Payment.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							User Information
						</div>
						<p className='cortex-privacy-content-p'>
							Some functionality of the Application, including Online Payment and location based services
							and functionality, may require the transmission of information provided by the User
							including user names and passwords, addresses, e-mail addresses, financial information (such
							as credit card numbers), device information, or GPS location (“User Information”). If the
							User uses such Application functionality, the User consents to the transmission of User
							Information to Cortex, its agents and/or service providers and authorizes Cortex, its agents
							and/or service providers to record, process and store such User Information as necessary for
							the Application functionality and for purposes described in the Cortex Privacy Policy
							(located at <Link to='/privacypolicy/'> https://www.cortex.ph/ privacypolicy/</Link>). The
							User is solely responsible for maintenance of the confidentiality and security of any User
							Information transmitted from or stored on a Device for purposes of the Application,
							including Online Payment, for all transactions and other activities, whether authorized or
							unauthorized. The User agrees to immediately notify Cortex of any unauthorized transactions
							associated with the Application including Online Payment or any other breach of security.
							Cortex shall not be responsible for any losses arising out of the loss or theft of User
							Information transmitted from or stored on a Device or from unauthorized or fraudulent
							transactions associated with the Application.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Acceptable Use
						</div>
						<p className='cortex-privacy-content-p'>
							Use by the User of the Application and any Content and User Information transmitted in
							connection with the Application is limited to the contemplated functionality. The User
							agrees that his or her use of the Application and any Content must comply with these Terms
							and the Cortex Policies. In no event may the Application be used in a manner that (a)
							harasses, abuses, stalks, threatens, defames or otherwise infringe or violate the rights of
							any other party (including but not limited to rights of publicity or other proprietary
							rights); (b) is unlawful, fraudulent or deceptive; (c) uses technology or other means to
							access the Application, Cortex Website or Content that is not authorized by Cortex; (d) use
							or launch any automated system, including without limitation, "robots," "spiders," or
							"offline readers," to access the Application, Cortex Website or Content; (e) attempts to
							introduce viruses or any other computer code, files or programs that interrupt, destroy or
							limit the functionality of any computer software or hardware or telecommunications
							equipment; (f) attempts to gain unauthorized access to Cortex computer network or user
							accounts; (g) encourages conduct that would constitute a criminal offense, or that gives
							rise to civil liability; (h) violates these Terms; (i) attempts to damage, disable,
							overburden, or impair Cortex servers or networks; or (j) fails to comply with applicable
							third party terms (collectively “Acceptable Use”). Cortex reserves the right, in its sole
							discretion, to terminate any User License, terminate any User’s participation in Online
							Payment, remove Content or assert legal action with respect to Content or use of the
							Application, including Online Payment, that Cortex reasonably believes is or might be in
							violation of these terms of Acceptable Use or Cortex Policies, but Cortex’s failure or delay
							in taking such actions does not constitute a waiver of its rights to enforce these Terms.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Indemnification
						</div>
						<p className='cortex-privacy-content-p'>
							At Cortex’s request, the User agrees to defend, indemnify, and hold harmless Cortex and its
							parent and other affiliated companies, and their employees, contractors, officers, and
							directors from any and all claims, suits, damages, costs, lawsuits, fines, penalties,
							liabilities, expenses (including attorney's fees) that arise from the User’s use or misuse
							of the Application (including Online Payment), violation of these Terms or violation of any
							rights of a third party. Cortex reserves the right to assume the exclusive defense and
							control of any matter otherwise subject to indemnification by the User, in which event the
							User will cooperate in asserting any available defenses. In the event of any third party
							claim that the Application or User’s possession and use of the Application infringes that
							third party’s intellectual property right, Cortex, not Apple, will be solely responsible for
							the investigation, defense, settlement and discharge of any such intellectual property
							infringement claim.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							No Warranties
						</div>
						<p className='cortex-privacy-content-p'>
							CORTEX IS PROVIDING THE APPLICATION TO THE USER "AS IS" AND THE USER IS USING THE
							APPLICATION AT HIS OR HER OWN RISK. TO THE FULLEST EXTENT ALLOWABLE UNDER APPLICABLE LAW,
							CORTEX DISCLAIMS ALL WARRANTIES AND CONDITIONS, WHETHER EXPRESS OR IMPLIED, INCLUDING ANY
							WARRANTIES OR CONDITIONS THAT THE APPLICATION IS MERCHANTABLE, OF SATISFACTORY QUALITY,
							RELIABLE, ACCURATE, FIT FOR A PARTICULAR PURPOSE OR NEED, NON-INFRINGING OR FREE OF DEFECTS
							OR ERRORS OR ABLE TO OPERATE ON AN UNINTERRUPTED BASIS, OR THAT THE USE OF THE APPLICATION
							BY THE USER IS IN COMPLIANCE WITH LAWS APPLICABLE TO THE USER OR THAT USER INFORMATION
							TRANSMITTED IN CONNECTION WITH THE APPLICATION (INCLUDING AS PART OF ONLINE PAYMENT) WILL BE
							SUCCESSFULLY, ACCURATELY OR SECURELY TRANSMITTED. In the event of any failure of the
							Application to conform to any applicable warranty, User may notify Apple, and, if
							applicable, Apple will refund the purchase price (if any) for the Application to the User
							and, to the maximum extent permitted by applicable law, Apple will have no other warranty
							obligation whatsoever with respect to the Application, and any other claims, losses,
							liabilities, damages, costs or expenses attributable to any failure to conform to any
							warranty will be Cortex’s sole responsibility.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							No Liability
						</div>
						<p className='cortex-privacy-content-p'>
							TO THE FULLEST EXTENT ALLOWABLE UNDER APPLICABLE LAW, IN NO EVENT SHALL CORTEX AND ITS
							PARENT AND OTHER AFFILIATED COMPANIES (A) BE LIABLE TO THE USER WITH RESPECT TO USE OF THE
							APPLICATION, INCLUDING WITHOUT LIMITATION PARTICIPATION IN ONLINE PAYMENT; AND (B) BE LIABLE
							TO THE USER FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR EXEMPLARY
							DAMAGES, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF GOODWILL, LOST PROFI TS, LOSS,
							THEFT OR CORRUPTION OF USER INFORMATION, THE INABILITY TO USE THE APPLICATION OR DEVICE
							FAILURE OR MALFUNCTION. THE USER’S SOLE REMEDY IS TO CEASE USE OF THE APPLICATION OR TO
							CEASE PARTICIPATION IN ONLINE PAYMENT. TO THE FULLEST EXTENT ALLOWABLE UNDER APPLICABLE LAW,
							IN NO EVENT (BUT SUBJECT TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW) SHALL THE
							AGGREGATE LIABILITY OF CORTEX AND ITS PARENT OR OTHER AFFILIATED COMPANIES, WHETHER IN
							CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHER THEORY, ARISING OUT OF OR
							RELATING TO THE USE OF OR INABILITY TO USE THE APPLICATION EXCEED ANY COMPENSATION THE USER
							PAYS, IF ANY, TO CORTEX FOR ACCESS TO OR USE OF THE APPLICATION DURING THE SIX MONTHS PERIOD
							IMMEDIATELY PRIOR TO THE EVENT GIVING RISE TO SUCH LIABILITY. Certain legislation may imply
							warranties or conditions or impose obligations upon us which cannot be excluded, restricted
							or modified or cannot be excluded, restricted or modified except to a limited extent. These
							Terms must be read subject to these statutory provisions. If these statutory provisions
							apply, to the extent to which Cortex are able to do so, the liability of Cortex and its
							affiliates under those provisions will be limited, at its option to: (1) in the case of
							goods, the replacement of the goods or the supply of equivalent goods; the repair of the
							goods; the payment of the cost of replacing the goods or of acquiring equivalent goods; or
							the payment of the cost of having the goods repaired; and (2) in the case of services, the
							supplying of the services again; or the payment of the cost of having the services supplied
							again.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Marks, Application and Content
						</div>
						<p className='cortex-privacy-content-p'>
							Cortex, the Cortex logo, the Buddee logo, and other Cortex trademarks, service marks,
							graphics and logos used in connection with the Application are trademarks or registered
							trademarks of Cortex Corporation (collectively “Cortex Marks”). Other trademarks, service
							marks, graphics and logos used in connection with the Application are the trademarks of
							their respective owners (collectively “Third Party Marks”). The Cortex Marks and Third Party
							Marks may not be copied, imitated or used, in whole or in part, without the prior written
							permission of Cortex or the applicable trademark holder. The Application and the Content are
							protected by copyright, trademark, patent, trade secret, international treaties, laws and
							other proprietary rights, and also may have security components that protect digital
							information only as authorized by Cortex or the owner of the Content.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Governing Law and Jurisdiction
						</div>
						<p className='cortex-privacy-content-p'>
							These Terms are governed by the laws of the Philippines, without regard to conflict of laws
							rules. The United Nations Convention on Contracts for the International Sale of Goods shall
							have no applicability. The User irrevocably consents to the exclusive jurisdiction of the
							courts of the Philippines for purposes of any legal action arising out of or related to the
							use of the Application or these Terms.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Third Party Beneficiary
						</div>
						<p className='cortex-privacy-content-p'>
							Apple, and Apple’s subsidiaries, are third party beneficiaries of these Terms. Upon User’s
							acceptance of these Terms, Apple will have the right (and will be deemed to have accepted
							the right) to enforce these Terms against User as a third party beneficiary thereof.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Changes
						</div>
						<p className='cortex-privacy-content-p'>
							Cortex reserves the right to change or modify these Terms or any other Cortex policies
							related to use of the Application at any time and at its sole discretion by posting
							revisions on the Cortex Website. Continued use of the Application following the posting of
							these changes or modifications will constitute acceptance of such changes or modifications.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Severability
						</div>
						<p className='cortex-privacy-content-p'>
							If any provision of these Terms shall be deemed unlawful, void or for any reason
							unenforceable, then that provision shall be deemed severable from these Terms and shall not
							affect the validity and enforceability of any remaining provisions.
						</p>
						<div className='cortex-privacy-content-title' style={fontSize}>
							Contact Cortex
						</div>
						<p className='cortex-privacy-content-p'>
							Any questions, complaints or claims regarding the Application should be directed to:
						</p>
						<p className='cortex-privacy-content-p' style={{ paddingBottom: 100 }}>
							<div>Cortex Technologies Corporation </div>
							<div>KM 20 East Service Rd </div>
							<div> Cupang, Muntinlupa </div>
							<div> Philippines</div>
						</p>
					</div>
				</div>
			</ContentSnd>
			<Footer />
		</Layout>
	);
};
// style={{paddingBottom:100}}
export default TermsAndCondition;
